module.exports = __webpack_public_path__ + "img/asset_edit_white.5bf99a52.svg";